import * as api from '../displaysApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteDisplayConfig, displaysActionCreators } from '..';
import { DisplaysActionKeys } from '../displaysActionKeys';
import { uiActionCreators } from '../../ui';

function* deleteDisplayConfig(action: DeleteDisplayConfig) {
  yield put(uiActionCreators.showSpinnerDialog());
  yield call(api.deleteDisplayConfig, action.payload.userSid);

  yield put(displaysActionCreators.removeDisplayConfg(action.payload.userSid));

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteDisplayConfig() {
  yield takeEvery(DisplaysActionKeys.DELELTE_DISPLAY_CONFIG, deleteDisplayConfig);
}
